<script lang="ts">
  // @ts-nocheck
  import IFrameComponent from './iFrameComponent.svelte';
  import { onMount } from 'svelte';
  import * as css from './styles';

  import checkAvailableApp from '../common/services/UpiCheck';
  import type {
    AvailableApps,
    cartInterface,
    HydrogenCart,
    ItemInterface,
    linesInterface,
    MerchantInfoInterface,
    responseInterface,
    soTokenInterface,
    LocalStorageInterface,
  } from '../common/services/Interfaces';
  import { callCleverTap } from './Analytics/CleverTap';
  import { callKlaviyo } from './Analytics/Klaviyo';
  import { callWigzo } from './Analytics/Wigzo';
  import { callWebEngage, setNoteAttribute } from './Analytics/WebEngage';
  import { callMoengage } from './Analytics/Moengage';
  import { callFacebook } from './Analytics/Facebook';
  import { callGAanalyitcs } from './Analytics/GAAnalytics';
  import { callGrowlytics } from './Analytics/Growlytics';
  import { callContlo } from './Analytics/Contlo';
  import { callGA4 } from './Analytics/GA4';
  import { callNetcore } from './Analytics/Netcore';
  import { callSnapchat } from './Analytics/Snapchat';
  import {
    checkIfAndroid,
    setCookie,
    getCookie,
    deleteCookie,
    checkIfGlanceEnvironment,
    checkMerchantHealth,
    getPath,
    checkIfEmailBuggy,
    getIframeUrl,
    decryptEmail,
    isBase64,
    getGkCookieArray,
  } from './services/Helper.service';
  import { getCredUrl, analytics_api, XGokwikToken } from '../common/services/EnvironmentService';
  import { calledgeTag } from './Analytics/edgetag';
  import IFrameLoadingComponent from './iFrameLoadingComponent.svelte';
  import { callCustomerLabEvents } from './Analytics/CustomerLabs';
  import { callShopifyAnalytics } from './Analytics/ShopifyAnalytics';
  import { stabilityEvent } from './services/Event.service';

  let mid: string,
    url: string,
    sourceUrl: string,
    environment: string,
    cartObject: cartInterface,
    token: string,
    cartError: any,
    abcRequestId: string,
    sessionId: string,
    channelSource: string,
    channel: string,
    shopifySessionId: string = null,
    shopify_landing_page: string = '/',
    shopify_orig_referrer: string = 'blank',
    removeLoadingScreen: boolean = false,
    getCartCount: number = 0,
    gaCookies: string,
    modalWrapper: HTMLDivElement,
    sa_shopify_y: string,
    sa_shopify_t: string,
    sa_shopify_p: string,
    sa_localization: string,
    sp_duid: string,
    fbExternalId: string,
    kpFbCliId: string,
    kwikpass_user_token: string;
  let cashToPrepaidFlag: boolean = false;
  let launchDataRec = false;
  let showModal = true;
  let discountCode,
    isAbandonCart = false,
    _fbp,
    _fbc,
    cashToPrepaidRequestId;
  let sourceValue = 'direct',
    note_attributes = [];
  let jwtTokensArray: string[];
  let merchantInfo: MerchantInfoInterface;
  let availableApps: AvailableApps;
  let iosSafari = false,
    kwikKey,
    queryKwikKey,
    bpocStaticKey = '83t4834gr7456yr547',
    isSkipOtp: boolean = false,
    isAndroid: boolean = false,
    soToken: soTokenInterface,
    isHydrogen: boolean = false;
  let metaTag: HTMLMetaElement;
  let truecallerRequestId: string;
  const merchantUrl = window.location.href;
  let isGlanceEnvironment: boolean;
  let kpPhoneNumber: string = null,
    kpEmail: string = null,
    snapchatAttributes: any = {},
    localStorageObject: any = {};
  let isSameWindowRedirection: boolean;
  let isSuccess: boolean;
  let gokwikOid: string,
    showIframe: boolean = false;

  function checkIosChrome() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /CriOS/.test(userAgent) && /iPad|iPhone|iPod/.test(userAgent);
  }

  const truecallerConfig = {
    local: { name: 'Gokwik_Dev', key: 'dTG30d2de716a74ba4ab7b451cff60b2a4dd5' },
    // dev: { name: 'Gokwik_Dev', key: 'dTG30d2de716a74ba4ab7b451cff60b2a4dd5' },
    dev: { name: 'nDev', key: 'ZNCIFa82048349c2b41e4a441527c0de0cc9c' },
    ndev: { name: 'nDev', key: 'ZNCIFa82048349c2b41e4a441527c0de0cc9c' },

    production: { name: 'GoKwik', key: '8mf4fc98b53b622d94edc87c225d6096325f8' },
    sandbox: { name: 'Sandbox-GoKwik Commerce Solutions Pvt Ltd', key: '3nA4i1d7c49eccdf0487282c3f767f83735ae' },
    qa: { name: 'Qa-GoKwik Commerce Solutions Pvt Ltd', key: 'nkC7Q3d51583857ba4b88aa025a744cb75ef1' },
    qatwo: { name: 'QA-2', key: 'jNOxM140989a6a5e94de3bd265c370bc4f88a' },
  };
  function insertKeyframes() {
    const style = document.createElement('style');
    style.type = 'text/css';

    Object.entries(css).forEach(([key, value]) => {
      style.innerHTML += `.gokwik-${key} {
      ${value}
    }
      `;
    });
    document.head.appendChild(style);
  }

  let sessionIDFixMerchants = [
    '601yv16ivknsvathe',
    '19g6ilsls7oa4',
    '12wyqc2lkv1ku5f576t',
    '12wyqc2ke6xktk0klzf',
    '12wyqc2guqmkrw6406j',
  ];

  onMount(() => {
    // Call the function to insert the keyframes and start the animation
    insertKeyframes();

    const gkLoadEvent = new CustomEvent('gokwikLoaded');
    window.dispatchEvent(gkLoadEvent);
    isGlanceEnvironment = checkIfGlanceEnvironment();
    url = window.location.origin;
    sourceUrl = window.location.href;
    environment = window.merchantInfo.environment;
    addPrefetchTags();
    const userAgent = window.navigator.userAgent;
    if (
      (userAgent.indexOf('iPhone') !== -1 || userAgent.indexOf('iPad') !== -1 || userAgent.indexOf('iPod') !== -1) &&
      userAgent.indexOf('Safari') !== -1
    ) {
      iosSafari = true;
    }
      let cookie = {};
      document.cookie.split(';').forEach(function (el) {
        let [key, value] = el.split('=');
        cookie[key.trim()] = value;
      });
      shopifySessionId = cookie['_shopify_s'] || null;
    
    const queryParam = new URLSearchParams(window.location.search);
    if (queryParam.get('mrid')) {
      abcRequestId = queryParam.get('mrid');
      channelSource = queryParam.get('src');
      channel = queryParam.get('ch');
      queryKwikKey = queryParam.get('kwik');
      snapchatAttributes.click_id = queryParam.get('ScCid');
      isSameWindowRedirection = queryParam.get('isSameWindowRedirection') === 'true';
      isSuccess = queryParam.get('isSuccess') === 'true';
      gokwikOid = queryParam.get('gokwikOid');
      checkBpocKey();
      isAbandonCart = true;
      setCookiesOnCheckoutLoad();
      launchApp(window.merchantInfo ? window.merchantInfo : merchantInfo);
    }
    if (queryParam.get('so_token')) {
      soToken = { token: queryParam.get('so_token'), source: 'url' };
    }
    jwtTokensArray = getGkCookieArray(XGokwikToken());
    window.addEventListener('message', (event) => {
      if (event.data.type === 'merchantInfo') {
        setCookiesOnCheckoutLoad();
        if (queryParam.get('gk_token')) {
          try {
            const tokenData = JSON.parse(atob(queryParam.get('gk_token')));
            tokenData?.coreToken && setCookie(getTokenName(environment), tokenData?.coreToken, 365);
            tokenData?.coreToken && localStorage.setItem(getTokenName(environment), tokenData?.coreToken);
            tokenData?.token && setCookie('token', tokenData?.token, 365);
          } catch (error) {
            console.log(error);
          }
          launchApp(window.merchantInfo ? window.merchantInfo : merchantInfo);
        } else {
          let cookie = {};
          document.cookie.split(';').forEach(function (el) {
            let [key, value] = el.split('=');
            cookie[key.trim()] = value;
          });
          if (!soToken) soToken = { token: cookie['so_token'], source: 'cookie' };
          kpPhoneNumber = localStorage.getItem('kp-login-no') || getCookie('kp-login-no');
          launchApp(event.data);
        }
      } else if (event.data.type === 'cartOpen') {
        document.querySelector('.gokwik-checkout+div') &&
          document.querySelector('.gokwik-checkout+div').addEventListener('click', function () {
            setTimeout(() => {
              xhrPostCall(
                analytics_api(window.merchantInfo.environment),
                {},
                {
                  name: 'gokwik_other_checkout',
                  eventType: 'click',
                  type: 'event',
                  merchantId: '12wyqc2lkv1ku5f576t',
                  requestId: '12wyqc2lkv1ku5f576t',
                }
              );
            }, 2000);
          });
      } else if (event.data.type === 'checkoutHealth') {
        checkCheckouthealth(event.data);
      }
    });

    window.addEventListener('close_modal', () => {
      closeFrame();
      showModal ? (document.body.style.overflow = 'scroll') : '';
    });
    if (checkIfAndroid()) {
      const credUrl = getCredUrl(window.merchantInfo.environment);
      const checkApp = checkAvailableApp(credUrl);
      checkApp.then((res) => {
        if (res) {
          availableApps = {
            gpay: res[0],
            phonepe: res[1],
            credpay: res[2],
          };
        }
      });
    }
    if (window.merchantInfo.cashToPrepaid) {
      setCashToPrepaidConfigs();
    }
  });

  function setCookiesOnCheckoutLoad() {
    let cookie = {};
    document.cookie.split(';').forEach(function (el) {
      let [key, value] = el.split('=');
      cookie[key.trim()] = value;
    });
    if (!sessionIDFixMerchants.includes(window.merchantInfo.mid)) {
      shopifySessionId = cookie['_shopify_s'] || null;
    }
    snapchatAttributes.uuid_c1 = cookie['_scid'];
    sourceValue = cookie['gk_utm_source'] || cookie['_shopify_sa_p'];
    _fbp = cookie['_fbp'];
    _fbc = cookie['_fbc'];
    discountCode = cookie['discount_code'] ? cookie['discount_code'] : cookie['coupon_applied'];
    shopify_landing_page = cookie['gk_landing_page'] || '/';
    sp_duid = cookie['SP_DUID'] || null;
    shopify_orig_referrer = cookie['gk_orig_referrer'] || 'blank';
    sa_shopify_y = cookie['_shopify_y'] || '';
    sa_shopify_t = cookie['_shopify_sa_t'] || '';
    sa_shopify_p = cookie['gk_utm_source'] || cookie['_shopify_sa_p'] || '';
    sa_localization = cookie['localization'] || '';
    fbExternalId = cookie['kp_user_id'] || '';
    kwikpass_user_token = cookie['KWIKUSERTOKEN'] || '';
    kpFbCliId = cookie['kpmclid'] ? atob(cookie['kpmclid']) : getKpParamForFb(window.location.href) || '';
    gaCookies = getGaCookies(cookie);
  }


  //Fetch URL parameter if Present
  function getKpParamForFb(url) {
    const urlObj = new URL(url);
    const kpmclid = urlObj.searchParams.get('kpmclid');
    return kpmclid ? atob(kpmclid) : null;
  }

  function getGaCookies(cookies) {
    let matchingCookies = [];
    for (let cookieName in cookies) {
      if (cookieName.startsWith('_ga')) {
        let cookieValue = decodeURIComponent(cookies[cookieName]);
        matchingCookies.push(`${cookieName}=${cookieValue}`);
      }
    }
    return matchingCookies.length > 0 ? matchingCookies.join('; ') : null;
  }
  function setCashToPrepaidConfigs() {
    cashToPrepaidFlag = true;
    cashToPrepaidRequestId = localStorage.getItem('cash_to_prepaid') || getCookie('cash_to_prepaid');
    if (cashToPrepaidRequestId) {
      setTimeout(() => {
        const container = document.getElementById('gokwik-modal-wrapper');
        container && container.remove();
        document.getElementById('gokwik-div').append(container);
      }, 100);
      launchApp(window.merchantInfo);
      launchDataRec = true;
      showModal = false;
    }
  }

  function launchApp(data: MerchantInfoInterface) {
    // requestId = data.request_id;
    showIframe = true;
    buildAppInfo(data);
    window.addEventListener('message', messageEventListener);
  }
  function messageEventListener(event) {
    messageListener(event, getOrigin(environment));
  }
  async function buildAppInfo(data: MerchantInfoInterface) {
    merchantInfo = data;
    mid = data.mid;
    if (mid && ['production'].includes(merchantInfo?.environment)) {
      try {
        await checkMerchantHealth(mid, merchantInfo?.appFlow, merchantInfo?.cart || merchantInfo?.appCart, {
          requestId: sessionId,
          sessionId,
          mid,
          _fbc,
          _fbp,
          shopifySessionId,
          shopifyCookieInfo: {
            landing_page: shopify_landing_page,
            orig_referrer: shopify_orig_referrer,
            sa_shopify_y,
            sa_localization,
            sa_shopify_t,
            sa_shopify_p,
            domain_userid: sp_duid,
          },
          isAbandonCart,
          sourceValue,
        });
      } catch (error) {
        console.log('Error in checking merchant health: ', error);
      }
    }
    token = localStorage.getItem(getTokenName(environment));
    const kpEmailLocalStorage = localStorage.getItem('kp_email')
    if(kpEmailLocalStorage){
      if(isBase64(kpEmailLocalStorage)){
        kpEmail = await decryptEmail(kpEmailLocalStorage || '');
      }else{
        kpEmail = kpEmailLocalStorage
      }
    }

    // Valid email check if the email is buggy it will keep the normal flow going
    if (kpEmail && checkIfEmailBuggy(kpEmail)) {
      kpEmail = null;
    }
    let kpMultipleEmail, kpMultipleEmailLocalStorage = localStorage.getItem('kp_multiple_email')
    if(kpMultipleEmailLocalStorage){
        if(isBase64(kpMultipleEmailLocalStorage)){
          kpMultipleEmail = await decryptEmail(kpMultipleEmailLocalStorage) || '[]';
        }else{
          kpMultipleEmail = kpMultipleEmailLocalStorage
        }
    }

    try {
      if (!kpEmail && kpMultipleEmail) {
        const multipleEmails = JSON.parse(kpMultipleEmail) || [];

        const validEmails = multipleEmails.filter((emailObj) => !checkIfEmailBuggy(emailObj.email)); // Valid email check if any of the email is buggy it will keep the normal flow going

        const emailsWithOrders = validEmails.filter((emailObj) => emailObj.orders !== '0');

        if (emailsWithOrders.length === 1) {
          kpEmail = emailsWithOrders[0].email;
        } else if (emailsWithOrders.length > 1) {
          const maxOrdersEmail = emailsWithOrders.reduce((max, current) =>
            parseInt(current.orders) > parseInt(max.orders) ? current : max
          );

          if (emailsWithOrders.every((emailObj) => emailObj.orders === emailsWithOrders[0].orders)) {
            kpEmail = emailsWithOrders.map((emailObj) => emailObj.email).join(',');
          } else {
            kpEmail = maxOrdersEmail.email;
          }
        }
      }
    } catch (error) {
      console.log('Error in parsing multiple emails: ', error);
    }
    if (!kpEmail) {
      kpEmail = null;
    }

    localStorageObject.bikCustomerId = localStorage.getItem('bik-customer-id');
    localStorageObject.cf_user_customer_id = localStorage.getItem('cfit_user_customer_id');
    localStorageObject.cf_user_id = localStorage.getItem('cfit_user_id');
    localStorageObject.cf_dimension_id = localStorage.getItem('cfit_dimension_id');
    localStorageObject.cf_session_id = sessionStorage.getItem('cfit_session_id');
    removeLoadingScreen = false;
    if (token && token !== 'null' && !getCookie(getTokenName(environment))) {
      setCookie(getTokenName(environment), token, 365);
    }
    if (!token || token === 'null') {
      token = getCookie(getTokenName(environment));
    }
    token = token === 'null' ? null : token;
    localStorageObject.gkbuynow = localStorage.getItem('gkbuynow') == 'active' || getCookie('gkbuynow') == 'active';
    localStorageObject.gk_login_source = localStorage.getItem('gk_login_source') || getCookie('gk_login_source') || '';
    try {
      if (
        (merchantUrl.includes('sandbox') ||
          merchantUrl.includes('azanicare') ||
          merchantUrl.includes('qa-gokwik.myshopify')) &&
        webengage
      ) {
        note_attributes = setNoteAttribute([]);
      }
    } catch (error) {
      console.log(error);
    }
    sessionId = localStorage.getItem('gokwik-sessionID') || getCookie('gokwik-sessionID');
    if (!isAbandonCart && !cashToPrepaidFlag) {
      getCart();
    }
    if (data && environment) {
      const dataCheckArray: Array<keyof MerchantInfoInterface> = ['mid', 'environment'];
      dataCheckArray.forEach((param) => {
        if (!data[param]) {
          return;
        }
      });
      // url = window.location.origin;
      token = localStorage.getItem(getTokenName(environment));
      if (token && token !== 'null' && !getCookie(getTokenName(environment))) {
        setCookie(getTokenName(environment), token, 365);
      }
      if (!token || token === 'null') {
        token = getCookie(getTokenName(environment));
      }
      token = token === 'null' ? null : token;
      if (environment === 'local' && !isAbandonCart) {
        launchDataRec = true;
      }
      isAbandonCart && (launchDataRec = true);
      !cashToPrepaidFlag && applyHtmlModifications();
    }
    if (mid === 'eey3m3gkqgcov9i' && checkIosChrome()) {
      //fix for fablestreet ios issue
      setTimeout(() => {
        modalWrapper.style.position = 'absolute';
        setTimeout(() => {
          modalWrapper.style.position = 'fixed';
        }, 1000);
      }, 1000);
    }
  }

  function trueCallerLogin(merchantColor) {
    merchantColor = merchantColor.replace('#', '%23');
    window.location = getTruecallerDeeplink(environment, merchantColor);
    setTimeout(function () {
      if (document.hasFocus()) {
        console.log('Truecaller app not present on the device');
      } else {
        // truecaller found
        fetchTruecallerUser();
      }
    }, 1000);
  }

  function getTruecallerDeeplink(env, merchantColor) {
    return `truecallersdk://truesdk/web_verify?type=btmsheet&requestNonce=${getUniqueID()}&partnerKey=${
      truecallerConfig[env].key
    }&partnerName=${
      truecallerConfig[env].name
    }&lang=en&privacyUrl=https://www.gokwik.co/data-policy&termsUrl=https://www.gokwik.co/terms&loginSuffix=verifymobile&&ctaPrefix=continuewith&ctaColor=${merchantColor}&btnShape=rect&skipOption=useanothernum&ttl=15000`;
  }

  function getUniqueID() {
    var s4 = () =>
      Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    var id = s4() + s4() + '-' + mid.slice(mid.length - 5);
    truecallerRequestId = id;
    return id;
  }

  const fetchTruecallerUser = () => {
    let body = {
      type: 'fetch_truecaller_userdata',
      id: truecallerRequestId,
    };
    dispatchIframeEvent(body);
  };

  const checkCheckouthealth = (data) => {
    let gkIframe = document.getElementById('gokwik-iframe');
    gkIframe && gkIframe.contentWindow.postMessage(data, getPath(environment));
  };
  function messageListener(ev: MessageEvent, path: string) {
    if (ev && ev.origin === path) {
      if (ev.data.type === 'close') {
        // to handle 429
        if (ev.data.data.orderRetry) {
          setTimeout(() => {
            xhrGetCall(ev.data.data.merchantUrl + '/cart/clear.js');
          }, 2000);
        }
        closeFrame();
      } else if (ev.data.type === 'orderType') {
        localStorage.setItem('orderType', ev.data.token);
        setCookie('orderType', ev.data.token, 0);
      } else if (ev.data.type === 'token') {
        localStorage.setItem(getTokenName(environment), ev.data.token);
        setCookie(getTokenName(environment), ev.data.token, 365);
      } else if (ev.data.type === 'upiLink') {
        startUPIPayment(ev.data.link);
      } else if (ev.data.type === 'triggerCloseEvent') {
        triggerEventCall(ev.data.data);
      } else if (ev.data.type === 'userType') {
        localStorage.setItem('userType', ev.data.userType);
        setCookie('userType', ev.data.userType, 0);
      } else if (ev.data.type === 'cash_to_prepaid') {
        localStorage.setItem('cash_to_prepaid', ev.data.request_id);
        setCookie('cash_to_prepaid', ev.data.request_id, 365);
      } else if (ev.data.type === 'truecaller_login') {
        checkIfAndroid() && trueCallerLogin(ev.data.merchantColor);
      } else if (ev.data.type === 'remove_cash_to_prepaid') {
        localStorage.removeItem('cash_to_prepaid');
        deleteCookie('cash_to_prepaid');
      } else if (ev.data.type === 'auto_read_otp') {
        autoReadOtp();
      } else if (ev.data.type === 'removeKpLogin') {
        kpPhoneNumber && localStorage.removeItem('kp-login-no');
        kpPhoneNumber && setCookie('kp-login-no', '', -1);
      } else if (ev.data.type === 'appCallback') {
        gokwikSdk.emit(ev.data.response.name, ev.data.response);
      } else if (ev.data === 'clearGokwikIframeInterval') {
        removeLoadingScreen = true;
      } else if (ev.data.type === 'push_to_datalayer') {
        window.dataLayer && window.dataLayer.push(ev.data.data);
      } else if (ev.data.type === 'set_gk_storage') {
        let cookieData = ev.data.data?.cookie || null;
        let localStorageData = ev.data.data?.localStorage;
        if (cookieData) {
          setCookie(cookieData.name, cookieData.value, cookieData.expiry);
        }
        if (localStorageData) {
          localStorage.setItem(localStorageData.name, localStorageData.value);
        }
      } else if (ev.data.type === 'orderSuccess') {
        fireShopifyPurchaseEvent(ev.data.response);
      } else if (ev.data.type === 'call_geolocation_api') {
        callGeolocationAPI();
      } else if (ev.data.type === 'gk_open_abc_url') {
        createAndCloseIframe(ev.data.data.url);
      } else if (ev.data.type === 'update_shopify_cart') {
        updateShopifyCart();
      }
      if (environment !== 'local') {
        if (ev.data.analyticsName === 'shopifyAnalytics') {
          callShopifyAnalytics(ev.data.eventName, ev.data.data);
        } else if (ev.data.analyticsName === 'edgeTag') {
          calledgeTag(ev.data.eventName, ev.data.data);
        } else if (ev.data.analyticsName === 'cleverTap') {
          callCleverTap(ev.data.eventName, ev.data.data);
        } else if (ev.data.analyticsName === 'klaviyo') {
          callKlaviyo(ev.data.eventName, ev.data.data);
        } else if (ev.data.analyticsName === 'moengage') {
          callMoengage(ev.data.eventName, ev.data.data, merchantInfo.mid, merchantInfo);
        } else if (ev.data.analyticsName === 'webEngage') {
          callWebEngage(ev.data.eventName, ev.data.data);
        } else if (ev.data.analyticsName === 'growlytics') {
          callGrowlytics(ev.data.eventName, ev.data.data);
        } else if (ev.data.analyticsName === 'wigzo') {
          callWigzo(ev.data.eventName, ev.data.data);
        } else if (ev.data.analyticsName === 'facebook') {
          callFacebook(ev.data.eventName, ev.data.data);
        } else if (ev.data.analyticsName === 'snapchat') {
          callSnapchat(ev.data.data);
        } else if (ev.data.analyticsName === 'ga') {
          callGAanalyitcs(ev.data.eventName, ev.data.data);
        } else if (ev.data.analyticsName === 'gaNew') {
          callGA4(ev.data.eventName, ev.data.data);
        } else if (ev.data.analyticsName === 'customerLabs') {
          callCustomerLabEvents(ev.data.eventName, ev.data.data);
        } else if (ev.data.analyticsName === 'contlo_gk') {
          callContlo(ev.data.eventName, ev.data.data);
        } else if (ev.data === 'order_create_success') {
          localStorage.setItem('orderType', 'gokwik');
          setCookie('orderType', 'gokwik', 0);
        } else if (ev.data.type === 'redirect') {
          window.location.href = ev.data.url;
        } else if (ev.data.type === 'clear_cart') {
          // to avoid reloading before redirection
          setTimeout(() => {
            xhrGetCall(ev.data.url);
          }, 2000);
        } else if (ev.data.type == 'couponRemoved') {
          couponRemovedSuccess(ev.data);
        } else if (ev.data.type === 'modal_close_hydrogen') {
          gokwikSdk.emit('modal_closed', {});
          localStorage.removeItem('shopifyCartId');
          deleteCookie('shopifyCartId');
        } else if (ev.data.analyticsName === 'netcore') {
          callNetcore(ev.data.eventName, ev.data.data);
        } else if (ev.data.type === 'checkout_initiated') {
          gokwikSdk.emit(ev.data.type, {});
        }
      }
    }
  }

  async function updateShopifyCart() {
    try {
      await xhrPostCall(
        '/cart/update.js',
        {},
        {
          attributes: {
            Gokwik: 'Checkout',
          },
        }
      );
    } catch (error) {
      console.log(error);
    }
  }
  function couponRemovedSuccess(data) {
    var event = new CustomEvent('couponRemoved', {
      detail: {
        coupon: data.data,
      },
    });
    document.dispatchEvent(event);
  }

  function callGeolocationAPI() {
    let responseTimeout = setTimeout(() => {
      dispatchIframeEvent({
        type: 'geolocation_api_response',
        data: { error: 'Permission Rejected', position: { lat: '', lng: '' } },
      });
    }, 10000);
    navigator.geolocation.getCurrentPosition((position, error) => {
      clearTimeout(responseTimeout);
      let lat = position?.coords?.latitude + '';
      let lng = position?.coords?.longitude + '';
      dispatchIframeEvent({ type: 'geolocation_api_response', data: { error, position: { lat, lng } } });
    });
  }

  function closeFrame() {
    launchDataRec = false;
    isAbandonCart = false;
    showIframe = false;
    getCartCount = 0;
    showModal ? (document.body.style.overflow = 'scroll') : '';
    showModal && iosSafari && document.body.style.removeProperty('height');
    showModal && iosSafari && document.querySelector('html').style.removeProperty('height');
    showModal && iosSafari && document.querySelector('html').style.removeProperty('overflow');
    showModal && iosSafari && document.getElementById('iOSViewPort') && document.getElementById('iOSViewPort').remove();
    //@ts-ignore
    gokwikSdk.emit('modal_closed', {});
    let cashToPrepaidBox = document.getElementById('gokwik-div');
    if (cashToPrepaidBox) {
      cashToPrepaidBox.style.display = 'none';
    }
  }
  function startUPIPayment(link: string) {
    window.location.href = link;
  }

  async function triggerEventCall(obj) {
    if (!obj.requestId) {
      delete obj.requestId;
    }
    if (!obj.sessionId) {
      delete obj.sessionId;
    }
    await xhrPostCall(analytics_api(environment), {}, obj);
  }

  function getCart() {
    if (merchantInfo.cart) {
      cartObject = merchantInfo.cart;
      isHydrogen = true;
      launchDataRec = true;
      cartObject.gokwik_source_channel = 'shopify_checkout';
    } else if (merchantInfo.appFlow) {
      cartObject = merchantInfo.appCart;
      if (cartObject?.attributes) cartObject.attributes['appFlow'] = true;
      if (merchantInfo?.platform) cartObject.attributes['platform'] = merchantInfo.platform;
      if (merchantInfo?.source) cartObject.attributes['source'] = merchantInfo.source;
      if (merchantInfo?.tag) cartObject.attributes['tag'] = merchantInfo.tag;
      cartObject.gokwik_source_channel = 'shopify_checkout';
      launchDataRec = true;
    } else {
      let executionBegan = new Date().valueOf();
      environment !== 'local' &&
        xhrGetCall(window.location.origin + '/cart.js', {})
          .then(async (shopifyCartResponse) => {
            let executionEnd = new Date().valueOf();
            getCartCount++;
            if (shopifyCartResponse.items.length === 0) {
              if (getCartCount < 3) {
                getCart();
              } else {
                let eventBodyCart = {
                  shopifySessionId,
                  merchantId: merchantInfo?.mid,
                  name: 'cartjs_empty',
                  eventType: 'development',
                  type: 'event',
                  _fbc,
                  _fbp,
                  landing_page: shopify_landing_page,
                  orig_referrer: shopify_orig_referrer,
                  sa_shopify_y,
                  sa_shopify_p,
                  sa_shopify_t,
                  doman_userid: sp_duid,
                  sa_localization,
                  timestamp: Date.now(),
                  userAgent: navigator.userAgent,
                  abc_flag: isAbandonCart,
                  requestId: sessionId,
                  sessionId,
                  data: {
                    executionBegan,
                    executionEnd,
                    timeTaken: executionEnd - executionBegan,
                    sp_duid,
                  },
                };
                sourceValue && (eventBodyCart.source = sourceValue);
                await triggerEventCall(eventBodyCart);
                window.location.href = window.location.origin + '/cart';
              }
            } else {
              cartObject = shopifyCartResponse;
              cartObject.gokwik_source_channel = 'shopify_checkout';
              if (merchantInfo.mid == 'eey3k3mkrg55tcs') {
                cartObject.items = shopifyCartResponse.items.map((item: any) => {
                  item.item_category2 = 'Sandbox-item_category2';
                  item.item_category3 = 'Sandbox-item_category3';
                  item.item_category4 = 'Sandbox-item_category4';
                  item.item_category5 = 'Sandbox-item_category5';
                  item.item_list_id = 'Sandbox-item_list_id';
                  item.item_list_name = 'Sandbox-item_list_name';
                  return item;
                });
              }
              launchDataRec = true;
            }
            let eventBody = {
              shopifySessionId,
              merchantId: merchantInfo?.mid,
              name: 'cartjs_loaded',
              eventType: 'development',
              type: 'event',
              _fbc,
              _fbp,
              landing_page: shopify_landing_page,
              orig_referrer: shopify_orig_referrer,
              sa_shopify_y,
              sa_shopify_p,
              sa_shopify_t,
              domain_userid: sp_duid,
              sa_localization,
              timestamp: Date.now(),
              userAgent: navigator.userAgent,
              abc_flag: isAbandonCart,
              requestId: sessionId,
              sessionId,
              data: {
                executionBegan,
                executionEnd,
                timeTaken: executionEnd - executionBegan,
                sp_duid,
              },
            };
            sourceValue && (eventBody.source = sourceValue);
            stabilityEvent(
              {
                data: {
                  name: 'cartjs_empty',
                  type: 'error',
                },
              },
              {
                sessionId,
                mid,
                _fbc,
                _fbp,
                shopifySessionId,
                shopifyCookieInfo: {
                  landing_page: shopify_landing_page,
                  orig_referrer: shopify_orig_referrer,
                  sa_shopify_y,
                  sa_localization,
                  sa_shopify_t,
                  sa_shopify_p,
                  domain_userid: sp_duid,
                },
                isAbandonCart,
                sourceValue,
              }
            );
            triggerEventCall(eventBody);
          })
          .catch(() => (cartError = 'Unable to fetch cart. Please try again later.'));
    }
  }

  function getOrigin(env: string) {
    let url;
    if (env === 'local') {
      url = 'http://localhost:8080';
    } else if (env === 'dev' || env === 'hdev' || env === 'ndev') {
      url = 'https://dev.pdp.gokwik.co';
    } else if (env == 'sandbox') {
      url = 'https://sandbox.pdp.gokwik.co';
    } else if (env == 'production' || env === 'pci-prod') {
      url = 'https://pdp.gokwik.co';
    } else if (env == 'qa') {
      url = 'https://qa.pdp.gokwik.co';
    } else if (env == 'qatwo' || env === 'idev') {
      url = 'https://qatwo.pdp.gokwik.co';
    } else if (env === 'qa-rto') {
      url = 'https://qa2.pdp.gokwik.co';
    } else if (env === 'qaone') {
      url = 'https://qa1.pdp.gokwik.co';
    }
    return url;
  }
  function getTokenName(env: string) {
    if (env === 'dev' || env === 'local' || env === 'hdev' || env === 'qatwo' || env === 'ndev' || env === 'idev') {
      return 'SANDBOXKWIKSESSIONTOKEN';
    } else if (env === 'production' || env === 'pci-prod') {
      return 'KWIKSESSIONTOKEN';
    } else if (env === 'sandbox') {
      return 'SANDBOXKWIKSESSIONTOKEN';
    } else if (env === 'qa' || env === 'qa-rto' || env === 'qaone') {
      return 'QAKWIKSESSIONTOKEN';
    }
  }

  function initializeXhrHeaders(xhr, headers = {}) {
    xhr.setRequestHeader('Content-Type', 'application/json');
    for (const [key, value] of Object.entries(headers)) {
      xhr.setRequestHeader(key, value);
    }
  }
  export const getApiUrl = (env: string) => {
    let url;
    if (env === 'dev') {
      url = 'https://devapi.gokwik.co';
    } else if (env == 'sandbox') {
      url = 'https://sandbox.gokwik.co';
    } else if (env === 'production') {
      url = 'https://api.gokwik.co';
    } else if (env === 'qa') {
      url = 'https://qa-api.gokwik.co';
    } else if (env === 'hdev') {
      url = 'https://hdev.gokwik.co';
    } else if (env === 'ndev') {
      url = 'https://ndev.gokwik.co';
    } else if (env === 'local') {
      url = 'https://qa-api.gokwik.co';
    } else if (env === 'qatwo') {
      url = 'https://qatwo-api.gokwik.co';
    } else if (env === 'dev-core') {
      url = 'https://dev-core-api.dev.gokwik.co';
    } else if (env === 'qa-core') {
      url = 'https://qa-core-api.dev.gokwik.co';
    } else if (env === 'sandbox-core') {
      url = 'https://sandbox-core-api.dev.gokwik.co';
    } else if (env === 'pci-prod') {
      url = 'https://prod-core-api.gokwik.co';
    } else if (env === 'idev') {
      url = 'https://idev.gokwik.co';
    } else if (env === 'qa-rto') {
      url = 'https://qa2.pdp.gokwik.co';
    } else if (env === 'qaone') {
      url = 'https://qa1.pdp.gokwik.co';
    }

    return url;
  };

  function xhrGetCall(url, headers?) {
    return new Promise(function (resolve) {
      let xhr = new XMLHttpRequest();
      // xhr.responseType = 'json';
      xhr.open('GET', url);
      initializeXhrHeaders(xhr, headers);
      xhr.onload = function () {
        const response = JSON.parse(xhr.response);
        resolve(response);
      };
      xhr.onerror = function () {
        const response = JSON.parse(xhr.response);
        resolve(response);
      };
      xhr.send();
    });
  }
  function xhrPostCall(url, headers?, body) {
    return new Promise(function (resolve) {
      let xhr = new XMLHttpRequest();
      // xhr.responseType = 'json';
      xhr.open('POST', url);
      initializeXhrHeaders(xhr, headers);
      xhr.onload = function () {
        const response = JSON.parse(xhr.response);
        resolve(response);
      };
      xhr.onerror = function () {
        const response = JSON.parse(xhr.response);
        resolve(response);
      };
      xhr.send(JSON.stringify(body));
    });
  }

  function applyHtmlModifications() {
    iosSafari && (document.body.style.height = '100vh');
    iosSafari && (document.querySelector('html').style.height = '100vh');
    iosSafari && (document.querySelector('html').style.overflow = 'hidden');

    metaTag = document.createElement('meta');
    metaTag.name = 'viewport';
    metaTag.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
    iosSafari && (metaTag.id = 'iOSViewPort');
    document.getElementsByTagName('head')[0].appendChild(metaTag);
    document.body.style.overflow = 'hidden';

    let slidecartHQ = document.querySelector('#slidecarthq');
    if (slidecartHQ) {
      Array.from(slidecartHQ.childNodes).forEach((node) => {
        if (node.nodeType === 1) {
          node.style.zIndex = 2147483646;
        }
      });
    }
  }

  const checkBpocKey = () => {
    if (queryKwikKey === bpocStaticKey) {
      isSkipOtp = true;
    } else if (queryKwikKey) {
      kwikKey = queryKwikKey;
      isSkipOtp = true;
    }
  };
  const addPrefetchTags = () => {
    [getOrigin(environment), getApiUrl(environment)].forEach((url) => {
      const linkTag = document.createElement('link');
      linkTag.href = url;
      linkTag.rel = 'dns-prefetch';
      document.head.appendChild(linkTag);
    });
  };

  const autoReadOtp = async () => {
    if ('OTPCredential' in window && checkIfAndroid() && navigator.credentials) {
      const signal = new AbortController();
      let autoReadSHownEvent = { type: 'auto_read_shown' };
      dispatchIframeEvent(autoReadSHownEvent);
      let o: CredentialRequestOptions = {
        otp: { transport: ['sms'] },
        signal: signal.signal,
      };
      navigator.credentials
        .get(o)
        .then((res) => {
          if (res.code) {
            let body = { type: 'prefill_otp', data: res.code };
            dispatchIframeEvent(body);
            signal.abort();
          } else {
            signal.abort();
          }
        })
        .catch((e) => {
          signal.abort();
        });
    }
  };

  const dispatchIframeEvent = (body) => {
    document.getElementById('gokwik-iframe').contentWindow.postMessage(body, getPath(environment));
  };

  window.gokwikSdk.triggerLoadingScreen = function () {
    showIframe = true;
    removeLoadingScreen = false;
  };

  function fireShopifyPurchaseEvent(data) {
    window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish('gokwik_purchase_event', data);
  }

  function createAndCloseIframe(url: string) {
    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.id = 'gokwik-abc-iframe';
    iframe.className = 'gokwik-abc-iframe';
    iframe.style.position = 'fixed';
    iframe.style.top = '0';
    iframe.style.left = '0';
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.visibility = 'hidden';
    iframe.style.zIndex = '9999';
    document.body.appendChild(iframe);

    const analyticsInterval = setInterval(() => {
      const contentWindow = iframe.contentWindow;
      if (contentWindow) {
        contentWindow.fbq = null;
        contentWindow.gtag = null;
        contentWindow.ga = null;
        contentWindow.dataLayer = null;
        contentWindow?.Shopify?.analytics && (contentWindow.Shopify.analytics = null);
        contentWindow?.ShopifyAnalytics && (contentWindow.ShopifyAnalytics = null);
      }
    }, 50);

    setTimeout(() => {
      document.body.removeChild(iframe);
      clearInterval(analyticsInterval);
    }, 30000);
  }
</script>

<img
  src={`${getIframeUrl(window?.merchantInfo?.environment)}/assets/icons/gokwik_gif.gif`}
  id="small-icon"
  alt="gokwik_loading_gif"
  height="0px"
  width="0px"
  style="display: none;"
/>

{#if showIframe && !document.querySelector('#gokwik-modal-wrapper')}
  <div>
    <div
      id="gokwik-modal-wrapper"
      class={`${showModal ? 'gokwik-modalwrapper' : !cashToPrepaidFlag && 'gokwik-hideModal'}`}
      bind:this={modalWrapper}
    >
      <div class={!cashToPrepaidFlag && 'gokwik-modalbackground'} />
      {#if !window.merchantInfo.cashToPrepaid && !removeLoadingScreen}
        <IFrameLoadingComponent />
      {/if}
      {#if launchDataRec}
        <div class="{cashToPrepaidFlag ? 'gokwik-codPayClass' : `gokwik-modal`} gokwik-modal-content">
          <IFrameComponent
            {mid}
            {merchantInfo}
            {url}
            {availableApps}
            {environment}
            {cartObject}
            {discountCode}
            {sourceValue}
            {isAbandonCart}
            {cartError}
            {abcRequestId}
            {note_attributes}
            {sessionId}
            {_fbp}
            {channelSource}
            {channel}
            {_fbc}
            {isSkipOtp}
            {cashToPrepaidFlag}
            {cashToPrepaidRequestId}
            {soToken}
            {kwikKey}
            {isHydrogen}
            {sourceUrl}
            {shopifySessionId}
            {shopify_landing_page}
            {shopify_orig_referrer}
            {kpPhoneNumber}
            {snapchatAttributes}
            {localStorageObject}
            {isSameWindowRedirection}
            {isSuccess}
            {gokwikOid}
            {isGlanceEnvironment}
            {gaCookies}
            {sa_shopify_y}
            {sa_shopify_t}
            {sa_shopify_p}
            {sa_localization}
            {sp_duid}
            {kpEmail}
            {jwtTokensArray}
            {fbExternalId}
            {kpFbCliId}
            {kwikpass_user_token}
          />
        </div>
      {/if}
    </div>
  </div>
{/if}
